import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Core, PageWrapper, Section } from '@everfi/reactifi';

import everfi_homescreen_hero from '../images/everfi-homescreen-hero.jpg';
import ExploreMoreItem from './ExploreMoreItem';
import LessonsContentList from './lessonsContentList';
import mockData from './mock_playlist.json';
import { useHeapTracker } from '@lib/useHeapTracker';

function Pathways() {
  const playlists = mockData.data;
  const currentPlaylist = mockData.application.playlistId;
  const items = playlists.filter(item => item.id !== currentPlaylist);

  const { t } = useTranslation();
  // Retrieve data
  const { program_slug, playlist_slug } = useParams();
  const [pathwayData, setPathwayData] = useState({
    title: '',
    description: '',
    image: '',
  });

  useEffect(() => {
    // Mock fetch data slug TO REMOVE
    const fetchPathwayData = async () => {
      const data = {
        title: `Pathway title TEST ${program_slug}`,
        description: `Pathway Description ${playlist_slug}`,
        image: everfi_homescreen_hero,
      };
      setPathwayData(data);
    };
    fetchPathwayData();
  }, [program_slug, playlist_slug]);

  useHeapTracker();

  return (
    <>
      <PageWrapper>
        <Section>
          <Core.Layout bg="surface-page">
            <Core.Layout
              variant="grid"
              maxW="container.lg"
              gridTemplateColumns={{
                base: 'repeat(4, minmax(0, 1fr))',
                md: 'repeat(8, minmax(0, 1fr))',
                lg: 'repeat(12, minmax(0, 1fr))',
              }}
              gap="lg"
              py="lg"
              mx="auto"
            >
              <Core.Layout
                colSpan={{ base: '4', md: '5', lg: '8' }}
                display="flex"
                gap="md"
                flexDirection="column"
                alignItems="start"
              >
                <Core.Typography textStyle="h0" as="h1" style={{ margin: 0 }}>
                  {pathwayData.title || t('Pathway title goes here')}
                </Core.Typography>

                <Core.Typography variant="p1">
                  {pathwayData.description ||
                    'Nullam id dolor id nibh ultricies vehicula ut id elit duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit.'}
                </Core.Typography>
              </Core.Layout>
              <Core.Layout colSpan={{ base: '4', md: '3', lg: '4' }} rounded="lg" overflow="hidden">
                <Core.Image aspectRatio={16 / 9} path={pathwayData.image} />
              </Core.Layout>
            </Core.Layout>
          </Core.Layout>
          <Core.Layout
            variant="grid"
            maxW="container.lg"
            gridTemplateColumns={{
              base: 'repeat(4, minmax(0, 1fr))',
              md: 'repeat(8, minmax(0, 1fr))',
              lg: 'repeat(12, minmax(0, 1fr))',
            }}
            gap="lg"
            py="lg"
            mx="auto"
          >
            <Core.Layout colSpan={{ base: '4', md: '8', lg: '12' }} variant="flex" gap="lg" flexDirection="column">
              <LessonsContentList />
              <Core.Card size="lg">
                <Core.CardHeader stackDirection="row">
                  <Core.Typography variant="h2" style={{ margin: 0 }}>
                    {t('Explore more pathways')}
                  </Core.Typography>
                </Core.CardHeader>
                <Core.CardBody>
                  <Core.Layout variant="flex" flexDirection="row" gap="md" justifyContent="stretch">
                    {items.slice(0, 3).map(playlist => {
                      return (
                        <ExploreMoreItem
                          key={JSON.stringify(playlist)}
                          playlistTitle={playlist.attributes.name}
                          playlistImage={playlist.attributes.image_url}
                        />
                      );
                    })}
                  </Core.Layout>
                </Core.CardBody>
              </Core.Card>
            </Core.Layout>
          </Core.Layout>
        </Section>
      </PageWrapper>
    </>
  );
}
export default Pathways;
